import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export function ProtectedRoute({ children, requireOwner = false }) {
  const { user, loading } = useAuth();

  // loading is false by default — only true if we ever need a blocking check
  if (loading) return null;

  if (!user) return <Navigate to="/admin/login" replace />;
  if (requireOwner && user.role !== 'owner') return <Navigate to="/admin" replace />;

  return children;
}
